<script>
export let windSpeed;
</script>

<div>
    Wind: {windSpeed} km/h
</div>